"use client"
import { createContext, ReactNode, useContext } from "react"

const contextValue = {
    listingFilter: { use_month: "", listing_status: "", broker_status: "" },
    disneyResorts: [],
    nonDisneyResorts: []
}
const Context = createContext(contextValue)
export function useFilterData() {
    return useContext(Context)
}
export function FilterDataContextProvider({ filterData, children }: { filterData: typeof contextValue; children: ReactNode }) {
    return <Context.Provider value={filterData}>{children}</Context.Provider>
}
